import React from 'react';

import { ExternalLink } from '../common/Links/ExternalLink';
import { ConnectionString } from './ConnectionString.view';

import './ConnectMessages.scss';

export const NetworkProblemMessage: React.FC<{
  lastUrl: string;
}> = ({ lastUrl }) => (
  <>
    <h2 className="connect-message-title">Connection failed</h2>
    <p>
      {lastUrl ? (
        <>
          Failed to connect to <ConnectionString url={lastUrl} />
        </>
      ) : (
        'Failed to connect'
      )}
      .
    </p>
    <p>Make sure that:</p>
    <ul>
      <li>
        Your browser can <b>access the url</b> you have specified
      </li>
      <li>
        You are accessing the node over <b>https</b>
      </li>
      <li>
        If you are using Chrome and is accessing the node over <b>http</b> you can allow mixing http
        and https with a button in the left corner of the url bar. Click on it and then click the{' '}
        <b>Load unsafe script</b> button. You will need to do this for every browser session
      </li>
      <li>
        If you are using Firefox and is accessing the node over <b>http</b> you can allow mixing
        http and https by clicking on the green padlock and then click "Disable protection"
      </li>
      <li>
        Your browser <b>trusts the certificate</b> of your subscription
      </li>
      <li>There is no proxy in between that strips away Cross Origin headers</li>
    </ul>
    <p>
      Verify the connection by accessing the url directly and add an exception if your browser does
      not trust the certificate for your subscription.
    </p>
    {lastUrl && (
      <p>
        <ExternalLink href={lastUrl}>{lastUrl}</ExternalLink>
      </p>
    )}
    <p>You may also want to check the browser console to check if it gives any more clues.</p>
  </>
);
